module.exports = __webpack_public_path__ + "img/my_user.44fef4a0.png";